import { Injectable } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MapModalComponent } from '@app/shared/components/map-modal/map-modal.component';

@Injectable({
  providedIn: 'root',
})
export class MapModalService {
  constructor(private modalService: NgbModal) {}

  /**
   * Open map form
   * @param hotelsIds масив с ID-та на hotels
   * @param venuesIds масив с ID-та на venues
   * @param mapWrapperStyle pass custom styles to the wrapper modal for the map
   */
  public open(hotelsIds: Array<number>, venuesIds: Array<number> = [], mapWrapperStyle: any = {}): Promise<any> {
    let dynamicClass = '';

    if (mapWrapperStyle && Object.keys(mapWrapperStyle).length > 0) {
      dynamicClass = this.createDynamicModalClass(mapWrapperStyle);
    }

    const modal = this.modalService.open(MapModalComponent, { size: 'full' as 'lg', windowClass: dynamicClass || undefined });
    modal.componentInstance.hotelsIds = hotelsIds;
    modal.componentInstance.venuesIds = venuesIds;
    return modal.result;
  }

  // Needed as a helper to inject dynamic CSS (where needed) into the NgbModal's windowClass property
  public createDynamicModalClass(styles: Record<string, string>): string {
    const className = `dynamic-modal-${Math.random().toString(36).substring(2, 10)}`;
    const style = document.createElement('style');
    style.innerHTML = `
    .${className} .modal-dialog {
      ${Object.entries(styles)
      .map(([key, val]) => `${key}: ${val} !important;`)
      .join('\n')}
    }`;
    document.head.appendChild(style);
    return className;
  }
}
